import { type InjectionKey } from 'vue'
import { type LazyBlockToolsInject } from './types'

export const lazyBlockToolsInjectionKey = Symbol('lazyBlockTools') as InjectionKey<LazyBlockToolsInject>